import {cn, formatDate} from "../../../../../lib/utils.ts";
import {MoneyLabel} from "../../../../../components/general/MoneyLabel.tsx";
import * as React from "react";

export function TransactionInfo({data, onClick}: { data: Record<string, any>, onClick?: () => void }) {
    const isClickable = !!onClick;

    return (
        <div
            className={cn("border border-gray-300 p-4 w-1/2 rounded-s-lg ", isClickable && "hover:bg-gray-100 cursor-pointer")}
            onClick={onClick}
        >
            <h3 className="text-lg font-semibold text-gray-800">Transactie</h3>
            <div className="mt-2">
                <div className="flex justify-between py-1">
                    <span className="text-sm text-gray-600">Bedrag</span>
                    <span className="text-sm font-medium text-gray-900">€ <MoneyLabel
                        value={data?.amount / 100}/></span>
                </div>
                {data.relation_name && (
                    <div className="flex justify-between py-1">
                        <span className="text-sm text-gray-600">Relatienaam</span>
                        <span className="text-sm font-medium text-gray-900">{data.relation_name}</span>
                    </div>
                )}
                <div className="flex justify-between py-1">
                    <span className="text-sm text-gray-600">Omschrijving</span>
                    <span className="text-sm font-medium text-gray-900">{data.description}</span>
                </div>
                <div className="flex justify-between py-1">
                    <span className="text-sm text-gray-600">Transactiedatum</span>
                    <span className="text-sm font-medium text-gray-900">{formatDate(data.transaction_date)}</span>
                </div>
            </div>
        </div>
    );
}
